module.exports = __webpack_public_path__ + "roles.77988f8ced80ec1f7fd4dd20171d9cd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/roles.svg
// module id = 1151
// module chunks = 0